import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Tag } from "../Tag/Tag";
import useWorkSchedule from "../../hooks/useWorkSchedule";
import { isOffShift, shiftWindowLabel } from "../../utilities/workSchedule";

export interface OffShiftBadgeProps {
  className?: string;
}

/**
 * Badge que aparece SÓ quando o horário atual está fora do turno (08:00–17:00, espelho do
 * turno semeado no banco). Para telas de monitoramento ao vivo (mapa, sinótico, dashboard):
 * sinaliza que o instante corrente é "fora de turno". Reavalia a cada minuto para virar
 * sozinho na fronteira do turno, sem depender de um refresh de dados.
 */
const OffShiftBadge: React.FC<OffShiftBadgeProps> = ({ className }) => {
  const { t } = useTranslation("general");
  const schedule = useWorkSchedule();
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 60_000);
    return () => clearInterval(id);
  }, []);

  if (!isOffShift(new Date(), schedule)) return null;

  return (
    <Tag
      className={className}
      label={`${t("offShift")} · ${shiftWindowLabel(schedule)}`}
      severity="warningInverse"
      icon="bedtime"
    />
  );
};

export default OffShiftBadge;
